import React from 'react';
import moment from 'moment';
import classNames from 'classnames';

import PropTypeCampaign from '../utilities/propTypes/PropTypeCampaign';
import DetailsTable from './DetailsTable';
import TimeDisplay from './TimeDisplay';

const CampaignDetailsTable = ({
  name,
  tokenLabel,
  tokenAddress,
  formattedTokensPerCode,
  formattedTotalTokens,
  timestamp,
  status,
}) => {
  const rows = [
    { label: 'Name', value: name },
    { label: 'Token', value: tokenLabel || 'not set' },
    { label: 'Token Address', value: tokenAddress, className: 'address' },
    { label: 'Tokens Per Code', value: formattedTokensPerCode },
  ];
  if (formattedTotalTokens) {
    rows.push({ label: 'Number of Tokens', value: formattedTotalTokens });
  }
  if (timestamp) {
    rows.push({
      label: 'Date Created',
      value: <TimeDisplay date={moment.unix(timestamp).toDate()} />,
      className: 'date',
    });
  }
  if (status) {
    rows.push({
      label: 'Status',
      value: status.toString(),
      className: classNames({
        status: true,
        [status.toString()]: true,
      }),
    });
  }
  return <DetailsTable header="Campaign Summary" rows={rows} />;
};

CampaignDetailsTable.displayName = 'CampaignDetailsTable';

CampaignDetailsTable.propTypes = PropTypeCampaign;

export default CampaignDetailsTable;



// WEBPACK FOOTER //
// ./src/components/CampaignDetailsTable.js